import React from 'react';
import { Provider } from 'react-redux';
// GamePlayerUI imports
import store from '../store';
import GamePlayerUI from './UI';
// SCSS imports
import '../../../scss/GamePlayerUI/base.scss';

function PlayerApp() {
    
    return (
        <Provider store={store}>
            <GamePlayerUI />
        </Provider>
    );
}

export default PlayerApp;
